__webpack_require__.p = "https://game.bizplay.ee/";